import { Injectable } from '@angular/core';
import {
     HttpRequest,
     HttpHandler,
     HttpEvent,
     HttpInterceptor,
     HttpErrorResponse,
} from '@angular/common/http';
import { SessionService } from '../services/session.service';
import { catchError, Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {
     CTX_ERR_INVALID_SESSION,
     CTX_ERR_MISSING_AUTHORIZATION_HEADER,
} from '../contants';

/* https://stackoverflow.com/a/50970853 */
@Injectable()
export class WsHttpInterceptor implements HttpInterceptor {
     constructor(
          public auth: SessionService,
          private router: Router,
          private toastrService: ToastrService
     ) {}

     /**
      * intercept all XHR request
      * @param request
      * @param next
      * @returns {Observable<A>}
      */
     intercept(
          request: HttpRequest<any>,
          next: HttpHandler
     ): Observable<HttpEvent<any>> {
          let token = this.auth.getToken();
          // console.log('Check url ' + (token && request.url && request.url[0] === '/'), request.url)
          if (token) {
               /*&& request.url && request.url[0] === '/'*/
               request = request.clone({
                    setHeaders: { Authorization: token },
               });
          }
          let url = request.url;
          return next.handle(request).pipe(
               catchError((error, caught) => {
                    // intercept the responses error and displace it to the console
                    this.handleAuthError(error, url);
                    return of(error);
               }) as any
          );
     }

     /**
      * manage errors
      * @param err
      * @param url
      * @returns {any}
      */
     private handleAuthError(
          err: HttpErrorResponse,
          url: string
     ): Observable<any> {
          if (url.indexOf('/signout') === -1) {
               let ctxError = (err && err.error && err.error.ctxCode) || null;
               let shouldIntercept =
                    [
                         CTX_ERR_INVALID_SESSION,
                         CTX_ERR_MISSING_AUTHORIZATION_HEADER,
                    ].indexOf(ctxError) >= 0;
               // handle your auth error or rethrow
               if (ctxError && shouldIntercept) {
                    if (ctxError) {
                         this.toastrService.error(
                              window.appLang.YOUR_SESSION_EXPIRED
                         );
                    } else if (ctxError) {
                         this.toastrService.error(
                              window.appLang.GENERIC_ERROR_MSG +
                                   ' . (MISSING_AUTHORIZATION_HEADER)'
                         );
                    }
                    // navigate /delete cookies or whatever
                    this.auth.clear();
                    this.router.navigate([`/`]);
                    // if you've caught / handled the error, you don't want to rethrow it unless you also want downstream consumers to have to handle it as well.
                    return of(err.message);
               } else {
                    throw err;
               }
          } else {
               return of('');
          }
     }
}
